import { EmailSubfoldersBaseValueConverter } from 'General/Resources/ValueConverters/EmailSubfoldersBase';

export class EmailSubfoldersValueConverter extends EmailSubfoldersBaseValueConverter {
}